import { APIResponse } from "../models/APIResponse";
import { FinancialStatementRepository } from "../repositories/FinancialStatementRepository";
import { FinancialStatementView } from "../dto/FinancialStatement";

export class LoadFinancialStatement {
  constructor(private readonly repo: FinancialStatementRepository) {}

  execute(): Promise<APIResponse<FinancialStatementView | null>> {
    return this.repo.load();
  }
}

// Factory if you like this pattern
export const loadFinancial = (repo: FinancialStatementRepository) =>
  new LoadFinancialStatement(repo);
